import FullBodyIcon from "@assets/body-parts/full-body.svg";
import HeadTrunkIcon from "@assets/body-parts/head-trunk.svg";
import LowerLimbsIcon from "@assets/body-parts/lower-limbs.svg";
import UpperLimbsIcon from "@assets/body-parts/upper-limbs.svg";
import { ExerciseBodyPart } from "@domain/exercise/exercise";
import styled from "@emotion/styled";
import { SVGComponent } from "@typings/svg-component";
import { colors } from "@ui/style/colors";
import React, { SVGProps } from "react";

interface Props extends SVGProps<SVGElement> {
	bodyPart: ExerciseBodyPart;
	additionalBodyPartsCount?: number;
	width?: number;
	height?: number;
}

const bodyPartIconFromBodyPart: Record<ExerciseBodyPart, SVGComponent> = {
	[ExerciseBodyPart.FullBody]: FullBodyIcon,
	[ExerciseBodyPart.HeadTrunk]: HeadTrunkIcon,
	[ExerciseBodyPart.LowerLimbs]: LowerLimbsIcon,
	[ExerciseBodyPart.UpperLimbs]: UpperLimbsIcon,
};

export const BodyPartIcon = ({
	bodyPart,
	additionalBodyPartsCount = 0,
	width = 24,
	height = 24,
	...otherProps
}: Props): JSX.Element => {
	const Icon = bodyPartIconFromBodyPart[bodyPart];
	return (
		<Container width={width} height={height}>
			<Icon {...otherProps} width={width} height={height} />
			{additionalBodyPartsCount > 0 && <div className="p-size-xs-extra-bold">{`+${additionalBodyPartsCount}`}</div>}
		</Container>
	);
};

const Container = styled.div<{ width: number; height: number }>`
	width: ${({ width }) => width}px;
	height: ${({ height }) => height}px;
	position: relative;

	> div {
		position: absolute;
		top: -10px;
		right: -6px;
		color: ${colors.grey};
	}
`;
